import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import EstagiariosLogged from '../../../../components/auth/rh/estagiarios'

function EstagiariosLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Estagiários - Recursos Humanos" />
                <HeaderLogged />
                <Container>
                   <EstagiariosLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default EstagiariosLoggedScreen;